
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb9af"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb9af"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $fEAII = parcelRequire("fEAII");

var $2yNhp = parcelRequire("2yNhp");

var $h2umr = parcelRequire("h2umr");

var $5ZoOd = parcelRequire("5ZoOd");

var $e3qhW = parcelRequire("e3qhW");

var $1S7aa = parcelRequire("1S7aa");

var $6PSIn = parcelRequire("6PSIn");

var $cWZn2 = parcelRequire("cWZn2");

var $43qV6 = parcelRequire("43qV6");
let $35da740d59af89ba$var$pdfWidth = 210; // mm
let $35da740d59af89ba$var$pdfHeight = 297; // mm
function $35da740d59af89ba$var$getPdfPageSize(orientation) {
    if (orientation == "l") return [
        $35da740d59af89ba$var$pdfHeight,
        $35da740d59af89ba$var$pdfWidth
    ];
    return [
        $35da740d59af89ba$var$pdfWidth,
        $35da740d59af89ba$var$pdfHeight
    ];
}
let $35da740d59af89ba$var$fontSizeList = [
    15,
    18,
    20,
    22,
    24,
    28,
    32,
    36,
    42,
    44,
    48,
    50
];
let $35da740d59af89ba$var$gridSizeList = [
    {
        name: "2 Ft",
        value: 0.04
    },
    {
        name: "4 Ft",
        value: 0.08
    },
    {
        name: "6 Ft",
        value: 0.12
    },
    {
        name: "8 Ft",
        value: 0.16
    },
    {
        name: "10 Ft",
        value: 0.2
    }
];
let $35da740d59af89ba$var$fontColorList = [
    {
        name: "Black",
        color: "#000000"
    },
    {
        name: "Red",
        color: "#e74c3c"
    },
    {
        name: "Green",
        color: "#008000"
    }
];
let $35da740d59af89ba$var$ConfigSettings = $cWZn2.dev;
let $35da740d59af89ba$var$baseUrl = $35da740d59af89ba$var$ConfigSettings.ADMIN_URL;
let $35da740d59af89ba$var$logoUrl = "./assets/logo.png";
const $35da740d59af89ba$var$compressPDF = true;
let $35da740d59af89ba$var$jsPdf = new (0, $1S7aa.default)("p", "mm", $35da740d59af89ba$var$getPdfPageSize("p"), $35da740d59af89ba$var$compressPDF);
let $35da740d59af89ba$var$pageWidth = $35da740d59af89ba$var$jsPdf.internal.pageSize.getWidth();
let $35da740d59af89ba$var$pageHeight = $35da740d59af89ba$var$jsPdf.internal.pageSize.getHeight();
let $35da740d59af89ba$var$floorPlannerController = null;
let $35da740d59af89ba$var$floorPlannerViewer = null;
let $35da740d59af89ba$var$configurationHelper = null;
let $35da740d59af89ba$var$floorplanningHelper = null;
let $35da740d59af89ba$var$areaDetailLists = [];
let $35da740d59af89ba$var$areaTypeLists = [];
let $35da740d59af89ba$var$saveFilename = "design";
let $35da740d59af89ba$var$selectedRoom = null;
let $35da740d59af89ba$var$selectedLabel = null;
let $35da740d59af89ba$var$selectedIcon = null;
let $35da740d59af89ba$var$areaSettingsTemplate = null;
let $35da740d59af89ba$var$iconSettingsTemplate = null;
let $35da740d59af89ba$var$iconsListTemplate = null;
let $35da740d59af89ba$var$PresetTemplate = null;
let $35da740d59af89ba$var$labelSettingsTemplate = null;
let $35da740d59af89ba$var$SettingsTemplateView = null;
let $35da740d59af89ba$var$alertAnimationName = "";
let $35da740d59af89ba$var$roomSettingPanel = document.getElementById("roomSettingPanel");
let $35da740d59af89ba$var$labelSettingPanel = document.getElementById("labelSettingPanel");
let $35da740d59af89ba$var$iconSettingPanel = document.getElementById("iconSettingPanel");
let $35da740d59af89ba$var$iconListPanel = document.getElementById("iconListPanel");
let $35da740d59af89ba$var$SettingPanel = document.getElementById("SettingPanel");
Handlebars.registerHelper("ifeq", function(a, b, options) {
    if (a == b) return options.fn(this);
    return options.inverse(this);
});
Handlebars.registerHelper("inc", function(value, options) {
    return parseInt(value) + 1;
});
/* Predefined Floorplanner Settings Options */ let $35da740d59af89ba$var$options = {
    viewer2d: {
        id: "floorPlannerViewer",
        viewer2dOptions: {
            "corner-radius": 7,
            "boundary-point-radius": 3.0,
            "boundary-line-thickness": 2.0,
            "boundary-point-color": "#030303",
            "boundary-line-color": "#090909",
            pannable: true,
            zoomable: true,
            scale: false,
            rotate: true,
            translate: true,
            dimlinecolor: "#3E0000",
            dimarrowcolor: "#FF0000",
            dimtextcolor: "#000000",
            pixiAppOptions: {
                resolution: 1
            },
            pixiViewportOptions: {
                passiveWheel: false
            }
        }
    },
    resize: true
};
/* Predefined Icons Loaded to Icons List UI */ function $35da740d59af89ba$var$loadIconList() {
    if (!$35da740d59af89ba$var$iconsListTemplate) $35da740d59af89ba$var$iconsListTemplate = Handlebars.compile(document.getElementById("iconsListTemplate").innerHTML);
    $35da740d59af89ba$var$iconListPanel.innerHTML = $35da740d59af89ba$var$iconsListTemplate($e3qhW);
    $35da740d59af89ba$var$iconListPanel.classList.add("show");
}
function $35da740d59af89ba$var$loadAreaData() {
    fetch($35da740d59af89ba$var$baseUrl + "fetch-area-details").then((response)=>{
        return response.json();
    }).then((data)=>{
        $35da740d59af89ba$var$areaDetailLists = data.data;
        $35da740d59af89ba$var$areaTypeLists = data.type;
    }).catch((error)=>{
        console.log(error);
    });
}
/* Predefined Area Loaded to Json */ $35da740d59af89ba$var$loadAreaData();
function $35da740d59af89ba$var$switchViewerToDraw() {
    $35da740d59af89ba$var$floorPlannerController.setViewerModeToDraw();
}
function $35da740d59af89ba$var$switchViewerToMove() {
    $35da740d59af89ba$var$floorPlannerController.setViewerModeToMove();
}
function $35da740d59af89ba$var$switchViewerToTransform() {
    $35da740d59af89ba$var$floorPlannerController.switchViewerToTransform();
}
/* Draw Arrow to Canvas Scene */ function $35da740d59af89ba$var$drawArrow() {
    $35da740d59af89ba$var$floorPlannerController.setViewerModeToDraw(true);
}
/* Unversal Font Size Change */ function $35da740d59af89ba$var$setFontSize(size) {
    $35da740d59af89ba$var$floorPlannerController.setFontSize(size);
}
/* Load Json to Canvas Scene */ function $35da740d59af89ba$var$loadDesign(filedata) {
    let reader = new FileReader();
    reader.onload = function(event) {
        let data = event.target.result;
        $35da740d59af89ba$var$floorPlannerController.model.loadSerialized(data);
    };
    reader.readAsText(filedata);
}
/* Add Icon to Canvas Scene */ function $35da740d59af89ba$var$addIcon(url, name) {
    let icon = {
        url: url,
        name: name
    };
    const img = new Image();
    img.src = icon.url;
    img.onload = function() {
        icon.width = img.naturalWidth;
        icon.height = img.naturalHeight;
        $35da740d59af89ba$var$floorPlannerController.insertIcons(icon);
        $("#navbarSupportedContent ul li").removeClass("active");
        $(".top-side-setting-panel").removeClass("show");
    };
}
/* Add Label to Canvas Scene */ function $35da740d59af89ba$var$addLabel() {
    let label = {
        text: "Label Text"
    };
    $35da740d59af89ba$var$floorPlannerController.insertLabels(label);
    $("#navbarSupportedContent ul li").removeClass("active");
}
/* Settings Popup Configure Function */ function $35da740d59af89ba$var$settingsOpen() {
    let size = (0, $h2umr.Configuration).getNumericValue((0, $h2umr.gridSize));
    let fontsize = (0, $h2umr.Configuration).getNumericValue((0, $h2umr.fontSize));
    let data = {
        size: size,
        gridSizeList: $35da740d59af89ba$var$gridSizeList,
        fontsizelist: $35da740d59af89ba$var$fontSizeList,
        fontsize: fontsize
    };
    if (!$35da740d59af89ba$var$SettingsTemplateView) $35da740d59af89ba$var$SettingsTemplateView = Handlebars.compile(document.getElementById("SettingsTemplate").innerHTML);
    $35da740d59af89ba$var$SettingPanel.innerHTML = $35da740d59af89ba$var$SettingsTemplateView(data);
    $35da740d59af89ba$var$SettingPanel.classList.add("show");
    $("input[name=size][value='" + data.size + "']").prop("checked", true);
    // $("input[name=size][value='" + data.size + "']"). prop('checked', true)
    $(document).find("#fontSizeInputUniversal").val(data.fontsize);
// $(document).find('#fontSizeInput').val(data.size);
}
/* Save Design Function */ function $35da740d59af89ba$var$saveDesign() {
    let data = $35da740d59af89ba$var$floorPlannerController.model.exportSerialized();
    let a = window.document.createElement("a");
    let blob = new Blob([
        data
    ], {
        type: "text"
    });
    a.href = window.URL.createObjectURL(blob);
    a.download = $35da740d59af89ba$var$saveFilename + ".json";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    $("#navbarSupportedContent ul li").removeClass("active");
}
function $35da740d59af89ba$var$saveScreenShot() {
    let data = $35da740d59af89ba$var$floorPlannerController.getImageData();
    console.log(data.image);
    var a = document.createElement("a"); //Create <a>
    a.href = data.image; //Image Base64 Goes here
    a.download = "ScreenShot.png"; //File name Here
    a.click(); //Downloaded file
}
/* Export Pdf Generate Function */ function $35da740d59af89ba$var$exportPdf() {
    const rooms = $35da740d59af89ba$var$floorPlannerController.model.floorplan.getRoomDataJson();
    const data = $35da740d59af89ba$var$floorPlannerController.getImageData();
    const img = new Image();
    img.src = data.image;
    img.onload = async function() {
        const imgWidth = img.naturalWidth;
        const imgHeight = img.naturalHeight;
        // Load logo first (async)
        const logoImg = new Image();
        logoImg.src = $35da740d59af89ba$var$logoUrl;
        logoImg.onload = function() {
            // HEADER HEIGHT
            const headerH = 20;
            // Get page sizes
            const pageW = $35da740d59af89ba$var$jsPdf.internal.pageSize.getWidth();
            const pageH = $35da740d59af89ba$var$jsPdf.internal.pageSize.getHeight();
            // ---- HEADER FUNCTION ----
            function drawHeader() {
                // Draw logo
                $35da740d59af89ba$var$jsPdf.addImage({
                    imageData: logoImg,
                    x: 5,
                    y: 3
                });
            }
            // ---- PAGE 1 ----
            drawHeader();
            // Margin under header
            const margin = 20;
            const usableTop = headerH + 4;
            const maxW = pageW - margin * 2;
            const maxH = pageH - usableTop - margin;
            const imgRatio = imgWidth / imgHeight;
            const pageRatio = maxW / maxH;
            let drawW, drawH;
            if (imgRatio > pageRatio) {
                drawW = maxW;
                drawH = maxW / imgRatio;
            } else {
                drawH = maxH;
                drawW = maxH * imgRatio;
            }
            // Center the image inside remaining space
            const left = (pageW - drawW) / 2;
            const top = usableTop + (maxH - drawH) / 2;
            $35da740d59af89ba$var$jsPdf.addImage(data.image, "PNG", left, top, drawW, drawH);
            // ---- PAGE 2 ----
            $35da740d59af89ba$var$jsPdf.addPage("p", "mm", $35da740d59af89ba$var$getPdfPageSize("p"));
            // drawHeader();
            $35da740d59af89ba$var$jsPdf.setFontSize(14);
            $35da740d59af89ba$var$jsPdf.text("Area Calculations Summary", 15, headerH + 10);
            const body = [
                ...rooms.rooms,
                [
                    {
                        content: `Net LIVABLE Area : ${rooms.total}`,
                        colSpan: 5,
                        styles: {
                            fillColor: "#10ac84",
                            textColor: "#FFFFFF",
                            halign: "right",
                            valign: "middle",
                            fontSize: 12
                        }
                    }
                ]
            ];
            (0, (/*@__PURE__*/$parcel$interopDefault($6PSIn)))($35da740d59af89ba$var$jsPdf, {
                head: [
                    [
                        "Code",
                        "Name",
                        "Factor",
                        "Net Size (Sq.ft)",
                        "Net Total (Sq.ft)"
                    ]
                ],
                headStyles: {
                    fillColor: "#10ac84"
                },
                body: body,
                rowPageBreak: "avoid",
                styles: {
                    fontSize: 10,
                    lineWidth: 1,
                    lineColor: "#10ac84",
                    valign: "middle",
                    cellPadding: 2
                },
                columnStyles: {
                    2: {
                        halign: "center"
                    },
                    3: {
                        halign: "right"
                    },
                    4: {
                        halign: "right"
                    }
                },
                startY: headerH + 20
            });
            $35da740d59af89ba$var$jsPdf.save($35da740d59af89ba$var$saveFilename + ".pdf");
            // Reset PDF object (important)
            $35da740d59af89ba$var$jsPdf = (0, $1S7aa.default)("p", "mm", $35da740d59af89ba$var$getPdfPageSize("p"), $35da740d59af89ba$var$compressPDF);
            $("#navbarSupportedContent ul li").removeClass("active");
        };
    };
}
(0, $h2umr.Configuration).setValue((0, $h2umr.viewBounds), 10000); //In CMS
$35da740d59af89ba$var$floorPlannerController = new (0, $fEAII.FloorPlannerController)($35da740d59af89ba$var$options);
(0, $h2umr.Configuration).setValue((0, $h2umr.configDimUnit), (0, $5ZoOd.dimFeetAndInch));
$35da740d59af89ba$var$configurationHelper = $35da740d59af89ba$var$floorPlannerController.configurationHelper;
$35da740d59af89ba$var$floorplanningHelper = $35da740d59af89ba$var$floorPlannerController.floorplanningHelper;
$35da740d59af89ba$var$floorPlannerViewer = $35da740d59af89ba$var$floorPlannerController.floorplanner;
$35da740d59af89ba$var$floorPlannerController.model.addEventListener((0, $2yNhp.EVENT_LOADED), function() {
    console.log("LOAD SERIALIZED JSON ::: ");
});
$35da740d59af89ba$var$floorPlannerController.floorplanner.addFloorplanListener((0, $2yNhp.EVENT_NOTHING_SELECTED), function() {
    $(".right-side-setting-panel").removeClass("show");
    $(".top-side-setting-panel").removeClass("show");
    if ($35da740d59af89ba$var$floorPlannerController.getCurrentFloorplanMode() === (0, $43qV6.floorplannerModes).EDIT_ISLANDS) {
        if ($35da740d59af89ba$var$selectedRoom) $35da740d59af89ba$var$selectedRoom = null;
        $35da740d59af89ba$var$switchViewerToMove();
        $("#navbarSupportedContent ul li").removeClass("active");
    }
});
$35da740d59af89ba$var$floorPlannerController.floorplanner.addFloorplanListener((0, $2yNhp.EVENT_CORNER_CLICKED), function(evt) {});
$35da740d59af89ba$var$floorPlannerController.floorplanner.addFloorplanListener((0, $2yNhp.EVENT_WALL_CLICKED), function(evt) {});
$35da740d59af89ba$var$floorPlannerController.floorplanner.addFloorplanListener((0, $2yNhp.EVENT_WALL_DIMENSION_CLICKED), function(evt) {});
$35da740d59af89ba$var$floorPlannerController.floorplanner.addFloorplanListener((0, $2yNhp.EVENT_ROOM_DIMENSION_CLICKED), function(evt) {});
$35da740d59af89ba$var$floorPlannerController.floorplanner.addFloorplanListener((0, $2yNhp.EVENT_ARROW_CLICKED), function(evt) {
    $("#navbarSupportedContent ul li").removeClass("active");
});
$35da740d59af89ba$var$floorPlannerController.floorplanner.addFloorplanListener((0, $2yNhp.EVENT_ICONS_CLICKED), function(evt) {
    $35da740d59af89ba$var$selectedIcon = evt.item;
    let data = {
        rotation: evt.item.rotation,
        scale: evt.item.scale
    };
    if (!$35da740d59af89ba$var$iconSettingsTemplate) $35da740d59af89ba$var$iconSettingsTemplate = Handlebars.compile(document.getElementById("iconSettingsTemplate").innerHTML);
    $35da740d59af89ba$var$iconSettingPanel.innerHTML = $35da740d59af89ba$var$iconSettingsTemplate(data);
    $35da740d59af89ba$var$iconSettingPanel.classList.add("show");
});
$35da740d59af89ba$var$floorPlannerController.floorplanner.addFloorplanListener((0, $2yNhp.EVENT_LABEL_CLICKED), function(evt) {
    $35da740d59af89ba$var$selectedLabel = evt.item;
    let data = {
        rotation: evt.item.label.rotation,
        text: evt.item.label.text,
        fontsize: evt.item.label.style.fontSize,
        fontcolor: evt.item.label.style.fill,
        fontsizelist: $35da740d59af89ba$var$fontSizeList,
        fontcolorlist: $35da740d59af89ba$var$fontColorList
    };
    if (!$35da740d59af89ba$var$labelSettingsTemplate) $35da740d59af89ba$var$labelSettingsTemplate = Handlebars.compile(document.getElementById("labelSettingsTemplate").innerHTML);
    $35da740d59af89ba$var$labelSettingPanel.innerHTML = $35da740d59af89ba$var$labelSettingsTemplate(data);
    $35da740d59af89ba$var$labelSettingPanel.classList.add("show");
    $("input[name=color][value='" + data.fontcolor + "']").prop("checked", true);
    $(document).find("#fontSizeInput").val(data.fontsize);
});
$35da740d59af89ba$var$floorPlannerController.floorplanner.addFloorplanListener((0, $2yNhp.EVENT_ROOM_CLICKED), function(evt) {
    // console.log('RoomClick',evt.item);
    if ($35da740d59af89ba$var$floorPlannerController.getCurrentFloorplanMode() === (0, $43qV6.floorplannerModes).EDIT_ISLANDS) {
        $("#navbarSupportedContent ul li").removeClass("active");
        $("#TransformModel").addClass("active");
        return;
    }
    $35da740d59af89ba$var$loadAreaData();
    $35da740d59af89ba$var$selectedRoom = evt.item;
    let data = {
        code: $35da740d59af89ba$var$selectedRoom.code,
        description: $35da740d59af89ba$var$selectedRoom.name,
        factor: $35da740d59af89ba$var$selectedRoom.factor,
        type: $35da740d59af89ba$var$selectedRoom.roomType,
        list: $35da740d59af89ba$var$areaDetailLists,
        typelist: $35da740d59af89ba$var$areaTypeLists
    };
    let areadetail = $35da740d59af89ba$var$areaDetailLists.find((value)=>value.code === data.code);
    data.id = areadetail ? areadetail.id : 0;
    if (!$35da740d59af89ba$var$areaSettingsTemplate) $35da740d59af89ba$var$areaSettingsTemplate = Handlebars.compile(document.getElementById("areaSettingsTemplate").innerHTML);
    $35da740d59af89ba$var$roomSettingPanel.innerHTML = $35da740d59af89ba$var$areaSettingsTemplate(data);
    setTimeout(function() {
        $35da740d59af89ba$var$roomSettingPanel.classList.add("show");
    }, 100);
    if ($35da740d59af89ba$var$selectedRoom) {
        $(".presetarealistul li").removeClass("active");
        $(document).find("#areaCode" + data.id).addClass("active");
        $(document).find("#typeText").val(data.type);
        $("#navbarSupportedContent ul li").removeClass("active");
    }
});
function $35da740d59af89ba$var$hideErrorMsg(id) {
    $("#" + id + "_error").removeClass("show");
    $("#" + id + "_text").removeClass("error");
}
function $35da740d59af89ba$var$showErrorMsg(msg, id) {
    $("#" + id + "_error").html(msg);
    $("#" + id + "_text").addClass("error");
    $("#" + id + "_error").addClass("show");
}
$("#dummyClick").click(function(e) {
    $35da740d59af89ba$var$roomSettingPanel.classList.add("show");
});
$35da740d59af89ba$var$floorPlannerController.model.addEventListener((0, $2yNhp.EVENT_MODE_RESET), function(evt) {
    $("#navbarSupportedContent ul li").removeClass("active");
});
// floorPlannerController.model.loadSerialized(designJson);
/* Load Button Action Event */ var $35da740d59af89ba$var$importCabiPlanDesignFile = document.getElementById("importDesignFile");
$35da740d59af89ba$var$importCabiPlanDesignFile.addEventListener("change", function(event) {
    var files = $35da740d59af89ba$var$importCabiPlanDesignFile.files;
    $35da740d59af89ba$var$loadDesign(files[0]);
    $35da740d59af89ba$var$importCabiPlanDesignFile.value = "";
    $("#navbarSupportedContent ul li").removeClass("active");
}, true);
/* Validation Slider as Min and Max Value to Be exit check for corresponding textbox  */ function $35da740d59af89ba$var$SliderValidation(value, id, type) {
    if (!isNaN(value)) {
        if (id != "") {
            let min = parseFloat($("#" + id).attr("min"));
            let max = parseFloat($("#" + id).attr("max"));
            if (parseFloat(value) >= min && parseFloat(value) <= max) return true;
            else return false;
        } else return true;
    } else return false;
}
$(document).on("input", "#SearchInput", function(e) {
    let value = $(this).val();
    value = value.toLowerCase();
    let filteredareaDetails;
    fetch($35da740d59af89ba$var$baseUrl + "search-area-details", {
        method: "POST",
        body: JSON.stringify({
            keyword: value
        }),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        },
        cache: "default"
    }).then((response)=>{
        return response.json();
    }).then((data)=>{
        filteredareaDetails = data.data;
        if (!$35da740d59af89ba$var$PresetTemplate) $35da740d59af89ba$var$PresetTemplate = Handlebars.compile(document.getElementById("PresetTemplate").innerHTML);
        let listData = $35da740d59af89ba$var$PresetTemplate({
            list: filteredareaDetails
        });
        $(".presetarealistul").html(listData);
    }).catch((error)=>{
        console.log(error);
    });
});
/* Icons Scale Text Box Type Event  */ $(document).on("input change", ".slider-text", function() {
    let type = $(this).data("type");
    let id = $(this).data("id");
    let value = $(this).val();
    if (value != "") {
        let checkValidation = $35da740d59af89ba$var$SliderValidation(value, id, type);
        if (checkValidation) {
            if (id != "") {
                $("#" + id).val(value);
                $35da740d59af89ba$var$hideErrorMsg(id);
            }
            switch(type){
                case "iconScale":
                    $35da740d59af89ba$var$floorplanningHelper.iconScale = parseFloat(value);
                    break;
                case "iconRotate":
                    $35da740d59af89ba$var$floorplanningHelper.iconRotation = parseFloat(value);
                    break;
            }
        } else if (id != "") $35da740d59af89ba$var$showErrorMsg("your value is out of range", id);
    } else $35da740d59af89ba$var$showErrorMsg("please enter value", id);
});
/* Top Menu Button Action Event as Draw, Add Icon, Add Text, 
   Mark Arrow, Reset, Save, Load, Export PDF  */ $(".actionEvent").click(function(e) {
    $("#navbarSupportedContent ul li").removeClass("active");
    $(this).parent("li").addClass("active");
    let type = $(this).data("type");
    switch(type){
        case "draw":
            $35da740d59af89ba$var$switchViewerToDraw();
            break;
        case "move":
            $35da740d59af89ba$var$switchViewerToTransform();
            break;
        case "arrow":
            $35da740d59af89ba$var$drawArrow();
            break;
        case "addText":
            $35da740d59af89ba$var$addLabel();
            break;
        case "exportPdf":
            Swal.fire({
                title: "Please enter a filename for your PDF",
                input: "text",
                inputLabel: "",
                inputPlaceholder: "my PDF",
                allowOutsideClick: true,
                showCancelButton: true,
                cancelButtonColor: "#fff",
                confirmButtonText: "Save",
                cancelButtonText: "Close",
                showClass: {
                    popup: "animate__animated " + $35da740d59af89ba$var$alertAnimationName
                },
                inputValidator: (value)=>{
                    return new Promise((resolve)=>{
                        if (value !== "") resolve();
                        else resolve("Please Enter Filename");
                    });
                }
            }).then((result)=>{
                if (result.isConfirmed) {
                    if (result.value != "") {
                        $35da740d59af89ba$var$saveFilename = result.value;
                        $35da740d59af89ba$var$exportPdf();
                    }
                }
            });
            break;
        case "reset":
            Swal.fire({
                title: "",
                text: "This will clear everything in your page & load a blank canvas. Do you want to continue?",
                showCancelButton: true,
                confirmButtonColor: "#10ac84",
                cancelButtonColor: "#fff",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                showClass: {
                    popup: "animate__animated " + $35da740d59af89ba$var$alertAnimationName
                }
            }).then((result)=>{
                if (result.isConfirmed) {
                    $35da740d59af89ba$var$floorPlannerController.model.reset();
                    $(".right-side-setting-panel").removeClass("show");
                    $(".top-side-setting-panel").removeClass("show");
                }
            });
            break;
        case "save":
            Swal.fire({
                title: "Download file as",
                input: "text",
                inputLabel: "",
                inputPlaceholder: "my file name",
                allowOutsideClick: false,
                allowOutsideClick: true,
                showCancelButton: true,
                cancelButtonColor: "#fff",
                confirmButtonText: "Save",
                cancelButtonText: "Close",
                showClass: {
                    popup: "animate__animated " + $35da740d59af89ba$var$alertAnimationName
                },
                inputValidator: (value)=>{
                    return new Promise((resolve)=>{
                        if (value !== "") resolve();
                        else resolve("Please Enter Filename");
                    });
                }
            }).then((result)=>{
                if (result.isConfirmed) {
                    if (result.value != "") {
                        $35da740d59af89ba$var$saveFilename = result.value;
                        $35da740d59af89ba$var$saveDesign();
                    }
                }
            });
            break;
        case "load":
            $35da740d59af89ba$var$importCabiPlanDesignFile.click();
            break;
        case "addIcon":
            $35da740d59af89ba$var$loadIconList();
            break;
        case "settings":
            $35da740d59af89ba$var$settingsOpen();
            break;
    }
    e.preventDefault();
});
/* Define Area Preset List click Event Action  */ $(document).on("click", ".presetarealistul li a", function(e) {
    let id = $(this).data("id");
    $(".presetarealistul li").removeClass("active");
    $(this).parent("li").addClass("active");
    let areadetail = $35da740d59af89ba$var$areaDetailLists.find((value)=>value.id === id);
    $(document).find("#areaTitle").html(areadetail.code + " - " + areadetail.description);
    $(document).find("#codeText").val(areadetail.code);
    $(document).find("#descriptionText").val(areadetail.description);
    $(document).find("#factorText").val(areadetail.factor);
    $(document).find("#typeText").val(areadetail.type);
    $(document).find("#updateAreaId").val(areadetail.id);
    e.preventDefault();
});
/* Delete Action on Custom Label,Icons to Canvas  */ $(document).on("click", ".deletebtn", function(e) {
    Swal.fire({
        title: "Are you Sure ?",
        text: "Do you really want to remove it?",
        showCancelButton: true,
        confirmButtonColor: "#10ac84",
        cancelButtonColor: "#fff",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        showClass: {
            popup: "animate__animated " + $35da740d59af89ba$var$alertAnimationName
        }
    }).then((result)=>{
        if (result.isConfirmed) {
            $35da740d59af89ba$var$floorplanningHelper.deleteCurrentItem();
            $(".right-side-setting-panel").removeClass("show");
            $(".top-side-setting-panel").removeClass("show");
        }
    });
    e.preventDefault();
});
/* Close Button Action Event  */ $(document).on("click", ".closebtn", function(e) {
    $(".right-side-setting-panel").removeClass("show");
    $(".top-side-setting-panel").removeClass("show");
});
/* Define Area Assign Button Action Event  */ $(document).on("click", ".assignbtn", function(e) {
    if ($35da740d59af89ba$var$selectedRoom) {
        let code = $(document).find("#codeText").val();
        let areadetail = $35da740d59af89ba$var$areaDetailLists.find((value)=>value.code === code);
        $35da740d59af89ba$var$selectedRoom.code = code;
        $35da740d59af89ba$var$selectedRoom.name = $(document).find("#descriptionText").val();
        $35da740d59af89ba$var$selectedRoom.factor = $(document).find("#factorText").val();
        $35da740d59af89ba$var$selectedRoom.roomType = $(document).find("#typeText").val();
        $35da740d59af89ba$var$selectedRoom.baseColor = areadetail.color;
        $35da740d59af89ba$var$selectedRoom.floorplan.dispatchEvent({
            type: (0, $2yNhp.EVENT_ROOM_METADATA_CHANGED),
            item: $35da740d59af89ba$var$selectedRoom,
            value: $35da740d59af89ba$var$selectedRoom.code
        });
        $35da740d59af89ba$var$roomSettingPanel.classList.remove("show");
    }
    e.preventDefault();
});
/* Define Area Edit Button Action Event  */ $(document).on("click", ".editbtnaction", function(e) {
    $(".editbtns").hide();
    $(".assignbtn").hide();
    $(".updatebtn").show();
    $(".areatextbox").removeAttr("disabled");
    e.preventDefault();
});
/* Define Area Delete Button Action Event  */ $(document).on("click", ".deletebtnaction", function(e) {
    let id = $("#updateAreaId").val();
    let areaTitle = $("#areaTitle").html();
    Swal.fire({
        title: "Delete " + areaTitle + " ?",
        text: "Deleting the preset from this list will remove the preset for all users. Do you really want to remove it?",
        showCancelButton: true,
        confirmButtonColor: "#000000",
        cancelButtonColor: "#fff",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        showClass: {
            popup: "animate__animated " + $35da740d59af89ba$var$alertAnimationName
        }
    }).then((result)=>{
        if (result.isConfirmed) $.ajax({
            type: "GET",
            url: $35da740d59af89ba$var$baseUrl + "delete-area-details/" + id,
            data: {},
            dataType: "json",
            success: function(resultData) {
                if (resultData.status) {
                    $35da740d59af89ba$var$loadAreaData();
                    $35da740d59af89ba$var$roomSettingPanel.classList.remove("show");
                } else $(".code_error").html(resultData.message);
            }
        });
    });
    e.preventDefault();
});
/* Custom Label Add Custom Text  */ $(document).on("input change", "#labelTextInput", function(e) {
    let text = $(this).val();
    $35da740d59af89ba$var$floorplanningHelper.labelText = text;
});
/* Custom Label font Size Input Change  */ $(document).on("change", "#fontSizeInput", function(e) {
    let text = $(this).val();
    $35da740d59af89ba$var$floorplanningHelper.labelFontSize = text;
});
/* Custom Label font Size Input Change  */ $(document).on("change", "#fontSizeInputUniversal", function(e) {
    let size = parseInt($(this).val());
    // floorplanningHelper.labelFontSize = text;
    $35da740d59af89ba$var$configurationHelper.fontSize = size;
    $35da740d59af89ba$var$setFontSize(size);
});
/* Custom Label font Color Change  */ $(document).on("click", ".fontColorInput", function(e) {
    let text = $('input[name="color"]:checked').val();
    $35da740d59af89ba$var$floorplanningHelper.labelColor = text;
});
/* Grid Size Checkbox Event  */ $(document).on("click", ".gridSizeInput", function(e) {
    let text = $('input[name="size"]:checked').val();
    $35da740d59af89ba$var$configurationHelper.gridSize = parseFloat(text);
});
/* Rotate icons to Scale Drag Event  */ $(document).on("input change", "#iconScaleSlider", function() {
    let value = parseFloat($(this).val());
    $35da740d59af89ba$var$floorplanningHelper.iconScale = value;
    $("#iconScaleSlider_text").val(value);
});
/* Rotate icons to Slider Drag Event  */ $(document).on("input change", "#iconRotateSlider", function() {
    let value = parseFloat($(this).val());
    $35da740d59af89ba$var$floorplanningHelper.iconRotation = value;
    $("#iconRotateSlider_text").val(value);
});
/* Add icons to Canvas  */ $(document).on("click", ".iconlistul li", function(e) {
    let url = $(this).data("url");
    let name = $(this).data("name");
    $35da740d59af89ba$var$addIcon(url, name);
    e.preventDefault();
});
/* Rotate Event Action as icons and Custom Labels  */ $(document).on("click", ".rotateiconul li", function(e) {
    let type = $(this).data("type");
    let id = $(this).data("id");
    let rotation = 0;
    switch(id){
        case "icon":
            if ($35da740d59af89ba$var$selectedIcon) {
                rotation = $35da740d59af89ba$var$selectedIcon.icon.rotation;
                if (type == "left") $35da740d59af89ba$var$floorplanningHelper.iconRotation = rotation - 45;
                else $35da740d59af89ba$var$floorplanningHelper.iconRotation = rotation + 45;
            }
            break;
        case "label":
            if ($35da740d59af89ba$var$selectedLabel) {
                rotation = $35da740d59af89ba$var$selectedLabel.label.rotation;
                if (type == "left") $35da740d59af89ba$var$floorplanningHelper.labelRotation = rotation - 45;
                else $35da740d59af89ba$var$floorplanningHelper.labelRotation = rotation + 45;
            }
            break;
    }
    e.preventDefault();
});
/* Define area Popup Tab as Preset and New  */ $(document).on("click", ".tab-ul li", function(e) {
    let type = $(this).data("type");
    $(".tab-ul li").removeClass("active");
    $(this).addClass("active");
    switch(type){
        case "preset":
            $("#presetAreaDefine").show();
            $("#newAreaDefine").hide();
            break;
        case "new":
            $("#presetAreaDefine").hide();
            $("#newAreaDefine").show();
            break;
    }
    e.preventDefault();
});
/* Close Button Action Event */ $(document).on("click", ".cancelbtn", function(e) {
    $(".right-side-setting-panel").removeClass("show");
    $(".top-side-setting-panel").removeClass("show");
});
/* Define Area Insert Button Action Event */ $(document).on("click", ".insertbtn", function(e) {
    let code = $("#codeTextN").val();
    let description = $("#descriptionTextN").val();
    let factor = $("#factorTextN").val();
    let type = $("#typeTextN").val();
    $(".error_text").html("");
    if (code != "") {
        if (description != "") {
            if (factor != "") {
                if (type != "") {
                    if (factor.match(/^\d+.?\d*$/)) $.ajax({
                        type: "POST",
                        url: $35da740d59af89ba$var$baseUrl + "insert-area-detail",
                        data: {
                            code: code,
                            short_description: description,
                            factor: factor,
                            type: type
                        },
                        dataType: "json",
                        success: function(resultData) {
                            if (resultData.status) {
                                $35da740d59af89ba$var$loadAreaData();
                                if ($35da740d59af89ba$var$selectedRoom) {
                                    let areadetail = $35da740d59af89ba$var$areaTypeLists.find((value)=>value.id === parseInt(type));
                                    $35da740d59af89ba$var$selectedRoom.code = code;
                                    $35da740d59af89ba$var$selectedRoom.name = description;
                                    $35da740d59af89ba$var$selectedRoom.factor = factor;
                                    $35da740d59af89ba$var$selectedRoom.roomType = areadetail.type;
                                    $35da740d59af89ba$var$selectedRoom.baseColor = areadetail.color;
                                    $35da740d59af89ba$var$selectedRoom.floorplan.dispatchEvent({
                                        type: (0, $2yNhp.EVENT_ROOM_METADATA_CHANGED),
                                        item: $35da740d59af89ba$var$selectedRoom,
                                        value: $35da740d59af89ba$var$selectedRoom.code
                                    });
                                    $35da740d59af89ba$var$roomSettingPanel.classList.remove("show");
                                }
                            } else $(".code_error").html(resultData.message);
                        }
                    });
                    else $(".factor_error").html("Only Allowed Numbers");
                } else $(".type_error").html("Please Enter type");
            } else $(".factor_error").html("Please Enter factor");
        } else $(".description_error").html("Please Enter description");
    } else $(".code_error").html("Please Enter code");
    e.preventDefault();
});
/* Define Area Update Button Action Event */ $(document).on("click", ".updatebtn", function(e) {
    let code = $("#codeText").val();
    let description = $("#descriptionText").val();
    let factor = $("#factorText").val();
    let type = $("#typeText").val();
    let id = $("#updateAreaId").val();
    $(".error_text").html("");
    if (code != "") {
        if (description != "") {
            if (factor != "") {
                if (type != "") {
                    if (factor.match(/^\d+.?\d*$/)) {
                        let areadetail = $35da740d59af89ba$var$areaTypeLists.find((value)=>value.type === type);
                        $.ajax({
                            type: "POST",
                            url: $35da740d59af89ba$var$baseUrl + "update-area-detail",
                            data: {
                                code: code,
                                short_description: description,
                                factor: factor,
                                type: areadetail.id,
                                id: id
                            },
                            dataType: "json",
                            success: function(resultData) {
                                if (resultData.status) {
                                    $35da740d59af89ba$var$loadAreaData();
                                    if ($35da740d59af89ba$var$selectedRoom) {
                                        // let areadetail = areaTypeLists.find(value => value.id === parseInt(type));
                                        $35da740d59af89ba$var$selectedRoom.code = code;
                                        $35da740d59af89ba$var$selectedRoom.name = description;
                                        $35da740d59af89ba$var$selectedRoom.factor = factor;
                                        $35da740d59af89ba$var$selectedRoom.roomType = areadetail.type;
                                        $35da740d59af89ba$var$selectedRoom.baseColor = areadetail.color;
                                        $35da740d59af89ba$var$selectedRoom.floorplan.dispatchEvent({
                                            type: (0, $2yNhp.EVENT_ROOM_METADATA_CHANGED),
                                            item: $35da740d59af89ba$var$selectedRoom,
                                            value: $35da740d59af89ba$var$selectedRoom.code
                                        });
                                        $35da740d59af89ba$var$roomSettingPanel.classList.remove("show");
                                    }
                                } else $(".code_errorE").html(resultData.message);
                            }
                        });
                    } else $(".factor_errorE").html("Only Allowed Numbers");
                } else $(".type_errorE").html("Please Enter type");
            } else $(".factor_errorE").html("Please Enter factor");
        } else $(".description_errorE").html("Please Enter description");
    } else $(".code_errorE").html("Please Enter code");
    e.preventDefault();
});
$(document).keydown(function(e) {
    /* Delete Key Press */ if (e.keyCode === 46) Swal.fire({
        title: "Are you sure you want to delete this item ?",
        text: "",
        showCancelButton: true,
        confirmButtonColor: "#10ac84",
        cancelButtonColor: "#fff",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        showClass: {
            popup: "animate__animated " + $35da740d59af89ba$var$alertAnimationName
        }
    }).then((result)=>{
        if (result.isConfirmed) {
            $35da740d59af89ba$var$floorplanningHelper.deleteCurrentItem();
            $(".right-side-setting-panel").removeClass("show");
            $(".top-side-setting-panel").removeClass("show");
        }
    });
    /* Undo Key as Ctrl + Z Key Press */ if (e.keyCode == 90 && e.ctrlKey) {
        $35da740d59af89ba$var$floorplanningHelper.undoActions();
        $35da740d59af89ba$var$floorPlannerViewer.setLastAction();
        $(".right-side-setting-panel").removeClass("show");
        $(".top-side-setting-panel").removeClass("show");
    }
/* Take Screenshot Key testing */ // if(e.keyCode == 80 ){
//     saveScreenShot();
// }
});
let $35da740d59af89ba$var$isDirty = false;
// Mark page as modified when user interacts
document.addEventListener("mousedown", function() {
    $35da740d59af89ba$var$isDirty = true;
});
document.addEventListener("keydown", function() {
    $35da740d59af89ba$var$isDirty = true;
});
window.addEventListener("beforeunload", function(event) {
    if ($35da740d59af89ba$var$isDirty) {
        event.preventDefault();
        event.returnValue = "";
    }
});


//# sourceMappingURL=index.8af9130a.js.map
